var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Header"}},[_c('a',{attrs:{"href":"/zscx"}},[_c('h2',[_vm._v("全国职业技能入库查询系统")])])])}]

export { render, staticRenderFns }